import { ConfigOption } from '@ngx-formly/core';
import { DocumentDefinitionDropdownComponent } from './document-definition-dropdown/document-definition-dropdown.component';

export const MOBILE_DOCUMENTS_FORMLY_TYPES: ConfigOption['types'] = [
  { name: 'formly-document-definition-dropdown', component: DocumentDefinitionDropdownComponent, wrappers: ['simple-title'], },
]
